// SPDX-License-Identifier: AGPL-3.0-or-later

// Slaps that land on my character can knock it out: the third within KNOCKOUT_WINDOW_MS lays it down for
// KNOCKOUT_DOWN_MS. Lying down nothing lands; for KNOCKOUT_IMMUNE_MS from a knockout slaps land but count for nothing.
// Only my own client decides this, as it decides whether a slap lands at all: it answers the slap.
export const KNOCKOUT_SLAPS = 3;
export const KNOCKOUT_WINDOW_MS = 8000;
export const KNOCKOUT_DOWN_MS = 15_000;
export const KNOCKOUT_IMMUNE_MS = 60_000;

export type SlapOutcome = 'slapped' | 'knockout';

export class RoomKnockout {
	private landed: Array<number> = [];
	private downAt: number | null = null;

	// How a slap at me would land now; null while I lie knocked out. Changes nothing until land().
	outcome(now: number): SlapOutcome | null {
		if (this.down(now)) return null;
		if (this.downAt !== null && now - this.downAt < KNOCKOUT_IMMUNE_MS) return 'slapped';
		return this.recent(now).length + 1 >= KNOCKOUT_SLAPS ? 'knockout' : 'slapped';
	}

	// The answer went out.
	land(outcome: SlapOutcome, now: number): void {
		if (outcome === 'knockout') {
			this.landed = [];
			this.downAt = now;
		} else if (this.downAt === null || now - this.downAt >= KNOCKOUT_IMMUNE_MS) {
			this.landed = [...this.recent(now), now];
		}
	}

	down(now: number): boolean {
		return this.downAt !== null && now >= this.downAt && now - this.downAt < KNOCKOUT_DOWN_MS;
	}

	// When the last knockout ends (or ended); null without one.
	downUntil(): number | null {
		return this.downAt === null ? null : this.downAt + KNOCKOUT_DOWN_MS;
	}

	clear(): void {
		this.landed = [];
		this.downAt = null;
	}

	private recent(now: number): Array<number> {
		return this.landed.filter((at) => now - at < KNOCKOUT_WINDOW_MS);
	}
}
